import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#fe3c5b',
        secondary: '#35485d',
        accent: '#ff6b7d',
        error: '#e53935',
        info: '#1e88e5',
        success: '#43a047',
        warning: '#fb8c00',
      },
    },
  },
});
